import cl from 'clsx'

import { type KktuResponse } from '@synapex/shared2/gateway-rest-api'

import { fullItemText } from './utils'
import classes from './KktuSelect.module.scss'
import { ComponentPropsWithoutRef, forwardRef } from 'react'

export type KktuBadgeProps = {
    error?: boolean
    value: null | string
    data: KktuResponse
} & ComponentPropsWithoutRef<'div'>
export const KktuBadge = forwardRef<HTMLDivElement, KktuBadgeProps>(
    ({ value, data, className, error = false, ...props }, ref) => {
        return (
            <div
                {...props}
                ref={ref}
                className={cl(
                    classes.badge,
                    {
                        [classes.placeholder]: !value,
                        [classes.error]: error,
                    },
                    className
                )}
            >
                <div className={'truncate'}>
                    {fullItemText(data, value, 'Поиск ККТУ')}
                </div>
                <svg
                    className={'shrink-0'}
                    xmlns="http://www.w3.org/2000/svg"
                    width="8"
                    height="6"
                    viewBox="0 0 8 6"
                    fill="none"
                >
                    <path
                        d="M7 1.5L4 4.5L1 1.5"
                        stroke="#94A6AF"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            </div>
        )
    }
)
